export const getThemeOfGameBox = (value: string): Record<string, string> => {
    const themes = {
        dark: {
            '--gamebox-background-1': '#0c1622',
            '--gamebox-background-2': '#131b26',
            '--gamebox-background-3': '#1b2336',
            '--gamebox-background-stroke': '#3b4358',
            '--gamebox-background-secondary-stroke': '#ACAFFF',
            '--game-card-background': '#1b2336',
            '--game-card-header': '#242c3e',
            '--badge-in-progress': '#f6e9dc',
            '--badge-text': '#402121',
            '--badge-completed': '#26D602',
            '--badge-fail': '#ff0000',
            '--game-card-text-primary': '#ffffff',
            '--gamebox-text': '#ffffff',
            '--wager-background': '#384259',
            '--wager-background-2': '#9dadee',
            '--wager-stroke': '#ffffff',
            '--button-primary': '#ff6600',
            '--button-text': '#ffffff',
            '--button-secondary': '#242c3e',
            '--button-secondary-border': '#8883c3',
            '--game-card-board': '#545b72',
            '--game-card-inactive': 'rgba(8, 12, 24, 0.50)',
            '--gamebox-background-hover': '#27314a',
            '--gamebox-background-selected': '#27314a',
            '--game-card-text-secondary': '#FF6600',
            '--game-card-board-selected': '#ff6600',
            '--game-card-background-disable': '#171e2f',
            '--game-card-background-disable-board': '#2d313d',
            '--game-card-text-tertiary': '#FFF',
            '--button-primary-disabled': '#642b06',
            '--gamebox-background-disabled': '#20293d',
            '--gamebox-text-disable': '#666666',
            '--gamebox-background-stroke-disabeled': '#27314a',
            '--gamebox-notification-bg': '#FE0101',
            '--gamebox-notification-border': '#FFF',
            '--gamebox-icon': '#FFF',
            '--gamebox-brand-color': 'rgba(136, 152, 190, 0.10)',
        },
        lightGreen: {
            '--gamebox-background-1': '#f2f2f2',
            '--gamebox-background-2': '#ffffff',
            '--gamebox-background-3': '#f2f2f2',
            '--gamebox-background-stroke': '#54af3a',
            '--gamebox-background-secondary-stroke': '#ACAFFF',
            '--game-card-background': '#ffffff',
            '--game-card-header': '#54af3a',
            '--badge-in-progress': '#ffffff',
            '--badge-text': '#402121',
            '--badge-completed': '#ffd400',
            '--badge-fail': '#ff0000',
            '--game-card-text-primary': 'rgba(30, 30, 30, 0.93)',
            '--gamebox-text': '#000000',
            '--wager-background': '#b5bbc7',
            '--wager-background-2': '#54af3a',
            '--wager-stroke': '#ffffff',
            '--button-primary': '#54af3a',
            '--button-text': '#ffffff',
            '--button-secondary': '#54af3a',
            '--button-secondary-border': '#8ddf76',
            '--game-card-board': '#aacfa8',
            '--game-card-inactive': 'rgba(13, 37, 6, 0.50)',
            '--gamebox-background-hover': '#c5debe',
            '--gamebox-background-selected': '#c5debe',
            '--game-card-text-secondary': '#35b810',
            '--game-card-board-selected': '#54af3a',
            '--game-card-background-disable': '#54af3a',
            '--game-card-background-disable-board': '#54af3a',
            '--game-card-text-tertiary': '#FFF',
            '--button-primary-disabled': '#8ddf76',
            '--gamebox-background-disabled': '#f0f0f0',
            '--gamebox-text-disable': '#a2a2a2',
            '--gamebox-background-stroke-disabled': '#bcbfc7',
            '--gamebox-notification-bg': '#FE0101',
            '--gamebox-notification-border': '#FFF9F9',
            '--gamebox-icon': '#000000',
            '--gamebox-brand-color': 'rgba(84, 175, 58, 0.10)',
        },
        lightOrange: {
            '--gamebox-background-1': '#f2f2f2',
            '--gamebox-background-2': '#ffffff',
            '--gamebox-background-3': '#f2f2f2',
            '--gamebox-background-stroke': '#ff5800',
            '--gamebox-background-secondary-stroke': '#ACAFFF',
            '--game-card-background': '#ffffff',
            '--game-card-header': '#ff5800',
            '--badge-in-progress': '#ffffff',
            '--badge-text': '#402121',
            '--badge-completed': '#ffd400',
            '--badge-fail': '#ff0000',
            '--game-card-text-primary': 'rgba(30, 30, 30, 0.93)',
            '--gamebox-text': '#000000',
            '--wager-background': '#b5bbc7',
            '--wager-background-2': '#ff5800',
            '--wager-stroke': '#ffffff',
            '--button-primary': '#ff5800',
            '--button-text': '#ffffff',
            '--button-secondary': '#ff5800',
            '--button-secondary-border': '#e5570c',
            '--game-card-board': '#fc9f6d',
            '--game-card-inactive': 'rgba(22, 11, 11, 0.50)',
            '--gamebox-background-hover': '#FFD8C4',
            '--gamebox-background-selected': '#FFD8C4',
            '--game-card-text-secondary': '#ff5800',
            '--game-card-board-selected': '#ff5800',
            '--game-card-background-disable': '#54af3a',
            '--game-card-text-tertiary': '#FFF',
            '--game-card-background-disable-board': '#54af3a',
            '--button-primary-disabled': '#842f02',
            '--gamebox-background-disabled': '#f0f0f0',
            '--gamebox-text-disable': '#a2a2a2',
            '--gamebox-background-stroke-disabled': '#bcbfc7',
            '--gamebox-notification-bg': '#FE0101',
            '--gamebox-notification-border': '#FFF9F9',
            '--gamebox-icon': '#000000',
            '--gamebox-brand-color': 'rgba(255, 88, 0, 0.10)',
        },
    };

    return themes[value] || themes['dark'];
};
